// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAiYZUnNwoyZlOO1HgAXz02pHw5wqVKysw",
    authDomain: "gulli-39333.firebaseapp.com",
    projectId: "gulli-39333",
    storageBucket: "gulli-39333.appspot.com",
    messagingSenderId: "157785372572",
    appId: "1:157785372572:web:40dd06de121746b7fc7a59",
    measurementId: "G-3RGHT1C555",
    vapidKey: "BL7fflgqcGL3LOM2YtPevYR16NuJ0KyaT-U3e__GCw5scNVDkkKWD2lQSiXleG3qbkh-v_L8MmSsPVhZ8agbcks"
  },
  s3Bucket: 'gulli-development',
  cognito: {
    identityPoolId: 'us-east-1:d76ed665-1401-44fb-9d26-444bd10b6d0f', // e.g., 'us-east-1:xxx-xxx-xxx'
    region: 'eu-central-1', // For S3 operations (can differ from Identity Pool region)
    firebaseProjectId: 'gulli-39333',
    oidcProvider: 'securetoken.google.com/gulli-39333'
  },
  meta: {
    pixelId: '', // Disabled for dev; only production sends events
    capiEndpointUrl: ''
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
